import React, {Fragment, useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {Col} from "react-bootstrap";

import {service as ForgotPasswordService} from "../../../Services/ForgotPasswordService";
import {service as StreamBankAuthService} from "../../../Services/StreamBankAuthService";

import {DocumentUtils} from "../../../Utils";


import {ForgotPasswordForm} from "./ForgotPasswordForm";

export const ForgotPasswordComponent = props => {
    const user = useSelector(state => state.userState.user);
    const [password, setPassword] = useState('');
    const [password2, setPassword2] = useState('');

    useEffect(() => {
        StreamBankAuthService.Logout();
    }, []);

    useEffect(() => {
        if(user && user.publicContext !== true) {
            DocumentUtils.changePage("/programs");
        }
    }, [user]);

    const submit = () => {
        if(password === password2) {
            const key = DocumentUtils.GetQueryStringParameter("token");

            ForgotPasswordService.ResetPassword(key, password)
                .then((x) => {
                    if(x.success) {
                        DocumentUtils.changePage("/");
                    } else {
                        alert(x.message || "invalid login");
                    }
                }).catch((x) => {
                if(x.data && x.data.message) {
                    alert(x.data.message);
                } else {
                    alert(x.message || "invalid login");
                }
            });
        } else {
            alert("Password don't match");
        }
    };

    const updatePassword = (value) => {
        setPassword(value);
    };

    const updatePassword2 = (value) => {
        setPassword2(value);
    };

    return <Fragment>
        <Col xs={12} md={3} />
        <Col xs={12} md={6}>
            <ForgotPasswordForm
                Password={password}
                Password2={password2}
                UpdatePassword={updatePassword}
                UpdatePassword2={updatePassword2}
                Submit={submit}
            />
        </Col>
    </Fragment>;
};


